// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"dd8b661f","97":"e7feb3a1","154":"dd8b661f","236":"2ba903a0","852":"23155b8c"}[chunkId] + ".chunk.css";
};